<template lang="pug">
  aside.sidebar
    diretorias
    coordenadorias
    links-importantes.--sidebar
</template>

<style lang="scss">
  // Style
  .sidebar {
    position: relative;
  }
</style>

<script>
import Diretorias from 'MODULES/Diretorias'
import Coordenadorias from 'MODULES/Coordenadorias'
import LinksImportantes from 'COMPONENTS/LinksImportantes'
export default {
  components: {
    Diretorias,
    Coordenadorias,
    LinksImportantes
  }
}
</script>



// WEBPACK FOOTER //
// Sidebar.vue?30395d02